import ServiceCategoryPage from "../components/ServiceCategoryPage";
import glassFitterService from "../data/services/glassFitterService";

function GlassFitter() {
  return <ServiceCategoryPage service={glassFitterService} />;
}

export default GlassFitter;